import React, { Component } from 'react';

import Slider from 'react-slick';
import Lightbox from 'react-images';

export default class CustomSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenImage: false,
    };
  }

  handleClickImage = (e, index) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      isOpenImage: true,
      currentImage: index,
    });
  };

  handleCloseModal = (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      current: '',
    });
  };
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      isOpenImage: false,
    });
  }

  render() {
    const { images, sliderSettings } = this.props;
    const { isOpenImage, currentImage } = this.state;
    const imageLightbox = images.map((img) => ({ src: img }));

    console.log(currentImage, imageLightbox);

    return (
      <div>
        <Slider {...sliderSettings}>
          {images.map((image, i) => (
            <img key={i} src={image} onClick={(e) => this.handleClickImage(e, i)} />
          ))}
        </Slider>

        {isOpenImage && (
          <Lightbox
            onClose={() => this.closeLightbox()}
            onClickPrev={() => this.gotoPrevious()}
            onClickNext={() => this.gotoNext()}
            images={imageLightbox}
            currentImage={currentImage}
            onCloseRequest={this.handleCloseModal}
            isOpen={true}
            backdropClosesModal={true}
          />
        )}
      </div>
    );
  }
}
